import React from 'react';

const CustomerMainPart = ({ children, adminSideDrawer }) => {
  // pt-16 (64px) creates space for the sticky header so content isn't hidden.
  return (
    <main className="db-main pt-16" dir={adminSideDrawer ? 'ltr' : ''}>
      {children}
    </main>
  );
};

export default CustomerMainPart;
